import classnames from 'classnames';
import React, { FC } from 'react';
import { Text } from '../../../../../components/common';
import { Separator } from '../Separator';
import styles from './ItemName.scss';
import { IOuter } from './ItemName.types';
import { useMMGRSettings } from '../../../../../utils/hoc/withMMGRSettings';

export const ItemName: FC<IOuter> = ({ name, className, dataHook = 'panel-item-name' }) => {
  const {
    mmgrSettings: { isUIAlignmentsEnabled },
  } = useMMGRSettings();
  return (
    <>
      <Text
        weight="thin"
        size="small"
        className={classnames(styles.name, className)}
        title={name}
        dataHook={dataHook}
        secondary={isUIAlignmentsEnabled}
      >
        {name}
      </Text>

      <Separator />
    </>
  );
};
